import React from 'react';
import { Button, Input, Modal } from 'antd';
import './InputEmail.scss';

const OpenSuccess = ({ visible, onClose,time }: any) => {
  return <Modal centered visible={visible} onCancel={onClose} closable={false} footer={null} width={270}>
    <div style={{ paddingBottom: 50, textAlign: 'center' }}>
      <div style={{ marginBottom: 20 }}>
        <img src={require('../../assets/invite-sf/ic-finish.svg')} width={60}/>
      </div>
      <div style={{ fontWeight: 500, fontSize: 17, marginBottom: 10 }}>账号开通成功</div>
      <div>请查收邮件激活账号，您的体验会员时长为 {time} 天，请及时登录使用</div>
    </div>
    <div className={'islide-modal-footer'}>
      <Button style={{ color: '#FB4C3A' }} onClick={onClose}>好的</Button>
    </div>
  </Modal>;
};

export default OpenSuccess;